import Services from "../../service/ApiServices";
export const GET_LOCATIONS  = "GET_LOCATIONS";
export const GET_STATES = "GET_STATES";
export const GET_PROGRAMS ="GET_PROGRAMS";


export const GetLocations = async ()=>{   
    var response = await Services.Location.getLocations();   
    var primaryLocationResponse = await Services.Location.getPrimaryLocationId();  
    return {type: GET_LOCATIONS, locations:response.data, id:primaryLocationResponse.data}//.map((l)=>{return {key: l.key, id: l.id, code: l.code, name: l.name, type: l.type}}) }
}

export const GetStates = async ()=>{
    var response = await Services.Location.getStates();   
    return {type: GET_STATES, states:response.data }
}

export const GetPrograms = async()=>{
    var response = await Services.Location.getPrograms();     
    return{type: GET_PROGRAMS, programs:response.data}
}
